import {Router} from '@angular/router';
import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {
    SalesConciergeModalDynamicComponent
} from '../../../../local_libs/brother-dealerapp-component-salesconcierge-lib/lib/modules/salesconcierge/components/sales-concierge-modal-dynamic/sales-concierge-modal-dynamic.component';
import {ModalDynamicV3Service} from '../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';

@Component({
    selector: 'app-sales-concierge-box',
    templateUrl: './sales-concierge-box.component.html',
    styleUrls: ['./sales-concierge-box.component.scss']
})

export class SalesConciergeBoxComponent{
    @Output() buttonClicked: EventEmitter<void> = new EventEmitter();

    constructor(
        private modalDynamicV3Service: ModalDynamicV3Service
    ) {
    }

    async openModal() {
        this.buttonClicked.emit();
        this.modalDynamicV3Service.open(SalesConciergeModalDynamicComponent);
    }
}
